import translations from 'services/translations/translations';

/**
 * The dropdown lists the program works by, shown on the admin page of the choice lists but
 * not editable: the code compares their values (e.g. the statuses of the offers, the units of
 * the calculation), so a new value would break it. Their values and names are those of the
 * translations, the same the dropdowns show.
 */
export interface IReadOnlyChoiceList {
  area: string;
  key: string;
  // The object of the translations with the values as its keys, e.g. offers:statuses
  translations: string;
}

export const READ_ONLY_CHOICE_LISTS: IReadOnlyChoiceList[] = [
  {
    area: 'offers',
    key: 'offer-types',
    translations: `${translations.offers}:types`,
  },
  {
    area: 'offers',
    key: 'phases',
    translations: `${translations.offers}:phases`,
  },
  {
    area: 'offers',
    key: 'statuses',
    translations: `${translations.offers}:statuses`,
  },
  {
    area: 'offers',
    key: 'product-groups',
    translations: `${translations.products}:groups`,
  },
  {
    area: 'calculation',
    key: 'units',
    translations: `${translations.common}:units`,
  },
  {
    area: 'products',
    key: 'attribute-types',
    translations: `${translations.products}:attributeTypes`,
  },
  {
    area: 'products',
    key: 'price-types',
    translations: `${translations.products}:priceTypes`,
  },
  {
    area: 'products',
    key: 'measurement-types',
    translations: `${translations.products}:measurementTypes`,
  },
  {
    area: 'users',
    key: 'countries',
    translations: `${translations.userManagement}:countries`,
  },
];

// The values and names of a list; only the names that are text (no groups inside)
export const getReadOnlyChoices = (
  t: (key: string, options?: Record<string, unknown>) => unknown,
  list: IReadOnlyChoiceList
): { label: string; value: string }[] => {
  const names = t(list.translations, { returnObjects: true });
  if (names === null || typeof names !== 'object') {
    return [];
  }

  return Object.entries(names as Record<string, unknown>)
    .filter((entry): entry is [string, string] => typeof entry[1] === 'string')
    .map(([value, label]) => ({ label, value }));
};
